// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout .sidebar {
  height: 100vh;
  position: fixed;
  top: 8.3333333333vh;
  left: 0;
  background: #f7f7f7;
  width: 18.5%;
}
.layout .sidebar .menu {
  padding: 20px 10px;
}
.layout .sidebar .menu .sidebar-title {
  color: var(--dark-grey);
  font-weight: 600;
  margin-bottom: 10px !important;
}
.layout .sidebar .menu .sidebar-item {
  display: flex;
  align-items: center;
  height: 35px;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 10px;
  padding: 10px;
}
.layout .sidebar .menu .sidebar-item svg {
  margin-right: 15px;
}
.layout .sidebar .menu .sidebar-item svg path {
  stroke-width: 1;
  stroke: black;
}
.layout .sidebar .menu .sidebar-item-selected {
  display: flex;
  align-items: center;
  height: 35px;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 10px;
  padding: 10px;
  background-color: var(--benchmarking-color);
  color: white;
  font-weight: 500;
}
.layout .sidebar .menu .sidebar-item-selected svg {
  margin-right: 15px;
}
.layout .sidebar .menu .sidebar-item-selected svg path {
  stroke-width: 1.5;
  stroke: white !important;
}
.layout .sidebar .menu .sidebar-item:hover {
  background: var(--benchmarking-hover);
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Benchmarking/Scss/Sidebar.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,OAAA;EACA,mBAAA;EACA,YAAA;AACF;AAAE;EACE,kBAAA;AAEJ;AADI;EACE,uBAAA;EACA,gBAAA;EACA,8BAAA;AAGN;AADI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AAGN;AAFM;EACE,kBAAA;AAIR;AAHQ;EACE,eAAA;EACA,aAAA;AAKV;AADI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,2CAAA;EACA,YAAA;EACA,gBAAA;AAGN;AAFM;EACE,kBAAA;AAIR;AAHQ;EACE,iBAAA;EACA,wBAAA;AAKV;AADI;EACE,qCAAA;EACA,eAAA;AAGN","sourcesContent":[".layout .sidebar {\n  height: 100vh;\n  position: fixed;\n  top: calc(100vh / 12);\n  left: 0;\n  background: #f7f7f7;\n  width: 18.5%;\n  .menu {\n    padding: 20px 10px;\n    .sidebar-title {\n      color: var(--dark-grey);\n      font-weight: 600;\n      margin-bottom: 10px !important;\n    }\n    .sidebar-item {\n      display: flex;\n      align-items: center;\n      height: 35px;\n      width: 100%;\n      margin-bottom: 10px;\n      border-radius: 10px;\n      padding: 10px;\n      svg {\n        margin-right: 15px;\n        path {\n          stroke-width: 1;\n          stroke: black;\n        }\n      }\n    }\n    .sidebar-item-selected {\n      display: flex;\n      align-items: center;\n      height: 35px;\n      width: 100%;\n      margin-bottom: 10px;\n      border-radius: 10px;\n      padding: 10px;\n      background-color: var(--benchmarking-color);\n      color: white;\n      font-weight: 500;\n      svg {\n        margin-right: 15px;\n        path {\n          stroke-width: 1.5;\n          stroke: white !important;\n        }\n      }\n    }\n    .sidebar-item:hover {\n      background: var(--benchmarking-hover);\n      cursor: pointer;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
